export const stateDefault = {
    historyReqest: false,
    historyReqestPending: false,
    showHistoryCheck: false,
    text: ''
};

export interface IStateType {
    historyReqest: boolean;
    historyReqestPending: boolean;
    showHistoryCheck: boolean;
    text: string;
}
